import {ObjectWrapper, ObjectWrapperFactory} from 'md-library-test-first-version';

export class Config {

    private objectWrapper: ObjectWrapper = null;

    private objectWrapperFactory: ObjectWrapperFactory = null;

    private data: any;

    // ########################################

    constructor(
        data: any,
        objectWrapperFactory: ObjectWrapperFactory
    ) {
        this.data = data;
        this.objectWrapperFactory = objectWrapperFactory;

        this.objectWrapper = this.objectWrapperFactory.create(this.data);
    }

    // ########################################

    public get(path?: string): any {
        return this.objectWrapper.get(path);
    }

    // ########################################
}
